// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1_iSH","inner":"Form_inner__1iqZe","range":"Form_range__3uMyH","name":"Form_name__2TLvh","actions":"Form_actions__KppJo"};